import React from 'react';
import "./designs.css";
import github from "../../assests/1 (1).jpg";
import github1 from "../../assests/1 (2).jpg"
import github2 from "../../assests/1 (3).jpg"
import github3 from "../../assests/1 (4).jpg";
import github4 from "../../assests/1 (5).jpg"
import github5 from "../../assests/1 (6).jpg"
import github6 from "../../assests/1 (7).jpg";
import github7 from "../../assests/1 (8).jpg"
import github8 from "../../assests/1 (9).jpg"
import github9 from "../../assests/1 (10).jpg";
import github10 from "../../assests/1 (11).jpg"
import github11 from "../../assests/1 (12).jpg"
import github12 from "../../assests/1 (13).jpg";
import github13 from "../../assests/1 (14).jpg"
import github14 from "../../assests/1 (15).jpg"
import github15 from "../../assests/1 (16).jpg";
import github16 from "../../assests/1 (17).jpg"
import github17 from "../../assests/1 (18).jpg"
import github18 from "../../assests/1 (19).jpg";
import github19 from "../../assests/1 (20).jpg"
import github20 from "../../assests/1 (21).jpg"
import github21 from "../../assests/1 (22).jpg"
import github22 from "../../assests/1 (23).jpg";
import github23 from "../../assests/1 (24).jpg"
import github24 from "../../assests/1 (25).jpg"
import github25 from "../../assests/1 (26).jpg";
import ThreeScene from '../profile/threescene';



const designsData = [
  { imgSrc: github, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github1, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github2, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github3, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github4, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github5, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github6, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github7, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github8, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github9, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github10, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github11, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github12, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github13, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github14, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github15, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github16, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github17, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github18, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github19, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github20, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github21, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github22, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github23, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github24, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  { imgSrc: github25, githubLink: "https://github.com/codewithAkram-ui/designs-" },
  
];

const Designs = () => {
  return (
    <div className="design-container">
      <ThreeScene/>
      {designsData.map((design, index) => (
        <div key={index} className="design-card">
          <a href={design.githubLink} target="_blank" rel="noopener noreferrer">
            <img src={design.imgSrc} alt={`Design ${index + 1}`} className="design-image" />
          </a>
        </div>
      ))}
    </div>
  );
}

export default Designs;